import React from "react"
import { Box, Grid, Palette, styled } from "@mui/material"

export type GridColor = 'lightSkyBlue' | 'midnightBlue'

interface ColoredGridProps {
    gridcolor: GridColor
}

const labelStyle = (gridColor: GridColor, palette: Palette) => {
    switch (gridColor) {
      case 'midnightBlue': return {
          '& .MuiInputLabel-root': {
              color: palette.midnightBlue.light,
              fontWeight: 500,
              transform: 'translate(0px, -21px) scale(0.75)'
          },
          '& .MuiInputLabel-root.Mui-disabled': {
              color: palette.action.disabled
          },
          '& .MuiInputLabel-root.Mui-focused': {
              color: palette.midnightBlue.light
          },
          '& .MuiTypography-h5': {
              color: palette.primary.main
          }
      }
      case 'lightSkyBlue': return {
          '& .MuiInputLabel-root': {
              color: palette.text.primary
          },
          '& .MuiInputLabel-root.Mui-disabled': {
              color: palette.action.disabled
          },
          '& .MuiInputLabel-root.Mui-focused': {
              color: palette.text.primary
          },
          '& .MuiTypography-h5': {
              color: palette.lightSkyBlue.contrastText
          }
      }
      default: {
          return {}
      }
  }
}

const getColoredGridStyles = (gridColor: GridColor, palette: Palette) => ({
    backgroundColor: palette[gridColor].main,
    border: '#00D2FF80 solid 1px',
    ...labelStyle(gridColor, palette)
})

// Generic function to create colored styled components
const createColoredComponent = <T extends React.ComponentType<any>>(component: T) =>
    styled(component)<ColoredGridProps>(({ theme, gridcolor }) => 
        getColoredGridStyles(gridcolor, theme.palette)
    )

export const ColoredGrid = createColoredComponent(Grid)
export const ColoredBox = createColoredComponent(Box)